const btns = $('.tabs__btn')
const items = $('.tabs__item')

btns.each(function (count, btn) {
    $(btn).on('click', function () {
        btns.each(function (_, item) {
            $(item).removeClass('active')
        })
        items.each(function (_, item) {
            $(item).removeClass('active')
        })
        $(btn).addClass('active')
        $(items[count]).addClass('active')
    })
})